import React from 'react';
import { useTranslator } from 'tradera-lang/translate';
import DfpAd from '@tradera/blueprint/components/lib/ads';
import ApplicationErrorBoundary from 'tradera-components/application-error-boundary/application-error-boundary';
import '@tradera/blueprint/components/lib/ads.css';
import WaitForConsentApiLoaded from 'tradera-components/wait-for-consent-api-loaded/wait-for-consent-api-loaded';
import { useIsFeatureEnabled } from 'tradera-hooks/use-is-feature-enabled';
import HolidAdWrapper from './holid-ad-wrapper';

const LocalizedDfpAd = props => {
    const { t } = useTranslator();
    const isCriteoDirectBidderEnabled = useIsFeatureEnabled(
        'ads-criteo-direct-bidder'
    );
    const isHolidAdsEnabled = useIsFeatureEnabled('ads-holid');
    const text = {
        label: t('dfpAd_label')
    };

    const adComponent = isHolidAdsEnabled ? (
        <HolidAdWrapper {...props} text={text.label} />
    ) : (
        <DfpAd
            {...props}
            text={text}
            isCriteoDirectBidderEnabled={isCriteoDirectBidderEnabled}
            isHolidAdsEnabled={false}
            isLoggingEnabled={false}
        />
    );
    return (
        <ApplicationErrorBoundary capture={false}>
            <WaitForConsentApiLoaded
                placeHolder={props.children}
                onLoadRender={() => adComponent}
            />
        </ApplicationErrorBoundary>
    );
};

export default LocalizedDfpAd;
